import { useLazyQuery } from "@apollo/client/react";
import { useEffect, useState } from "react";
import { adaptConexionesArray, GET_GRILLA_CONEXIONES } from "../../../data/graphQL/queries/AdminConexiones/getGrillaConexiones";

export const useGetConexionesRows = (filters, applyClientSideFilters, setIsRefetchRequired, delegacionOrigen) => {
  const [rows, setRows] = useState([]);
  const [originalData, setOriginalData] = useState([]);

  const [getConexiones, { data: dataConexiones, loading: conexionesLoading }] =
  useLazyQuery(GET_GRILLA_CONEXIONES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataConexiones) return;
    const dataAdapted = adaptConexionesArray(dataConexiones);
    setOriginalData(dataAdapted);
    const dataFilteredFromClientSide = applyClientSideFilters(
      dataAdapted,
      filters.txtFiltro
    );
    setRows(dataFilteredFromClientSide);
  }, [dataConexiones]);

  const handleSearch = () => {
    const { idDelegacion, month, year } = filters;
    setIsRefetchRequired(false);
    getConexiones({ variables: { idDelegacion, month: parseInt(month, 10), year: parseInt(year, 10) } });
  };

  useEffect(() => {
    if (delegacionOrigen) {
      handleSearch();
    }
  }, [delegacionOrigen]);

  return {
    rows,
    setRows,
    originalData,
    totalCount: rows.length || 0,
    loading: conexionesLoading,
    handleSearch
  };

};